










































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  extend,
} from "vee-validate";
import {
  required,
  email,
  alpha_spaces as alphaSpaces,
  numeric,
  min,
} from "vee-validate/dist/rules";

import UserType from "../types/user";

extend("required", required);
extend("email", email);
extend("alphaSpaces", alphaSpaces);
extend("numeric", numeric);

setInteractionMode("eager");

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class UserDialog extends Vue {
  @Prop() value: boolean;

  @Prop() userData!: UserType;

  @Prop() onSubmit: (value: UserType) => void;

  @Prop() onUpdate: (value: UserType) => void;

  newUser = this.userData === null;

  currentUser = { ...this.userData } || {
    name: "",
    email: "",
    age: null,
  };

  @Watch("userData")
  onUserDataChanged(val: UserType, oldVal: UserType) {
    this.newUser = val === null;
    this.currentUser = { ...val } || {
      _id: "",
      name: "",
      email: "",
      age: null,
    };
  }

  get isDialogOpen(): boolean {
    return this.value;
  }

  set isDialogOpen(value: boolean) {
    this.$emit("input", value);
  }

  close() {
    this.currentUser = {
      _id: "",
      name: "",
      email: "",
      age: 0,
    };
    this.isDialogOpen = false;
  }

  save() {
    if (this.newUser) this.$emit("submit", this.currentUser);
    else this.$emit("update", this.currentUser);
  }
}
